<template>
  <BIconCircleFill class="circle-icon" :class="{'is-hollow': isHollow}" />
</template>

<script setup>
import { BIconCircleFill } from "bootstrap-icons-vue";

const props = defineProps({
  isHollow: {
    type: Boolean,
    default: false,
  }
})


</script>

<style lang="scss" scoped>
.circle-icon {
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
}

.is-hollow {
  fill: transparent !important;
}
</style>
